import React from "react";

const DashboardSectionHeading: React.VFC<{ text?: string | null }> = ({ text }) =>
  text ? <div className="is-size-8 pt-1 pb-2 has-text-grey">{text}</div> : null;

export default DashboardSectionHeading;
